TS.ns('WL');

WL.leasingOfferSubsidyModel = new Class({
    Extends: WL.documentBase,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        me.showManualSubsidy = ko.computed(function () {
            if (me.Document.CalculationMethodCode != undefined && me.Document.CalculationMethodCode() == me.SubsidyCalculationMethodCodeForInterest())
                return true;
            return false;
        });

        me.showComputedSubsidy = ko.computed(function () {
            if (me.Document.CalculationMethodCode != undefined && me.Document.CalculationMethodCode() == me.SubsidyCalculationMethodCodeForSubsidy())
                return true;
            return false;
        });

    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var calculationMethod = me.getDomainProperty('lkpCalculationMethodId_Property');
        if (calculationMethod) {
            calculationMethod.on('selectionChanged', me.onCalculationMethodChanged, me);
            calculationMethod.autoSelect = true;
        }
    },

    onCalculationMethodChanged: function(newValue) {
        var me = this;

    }
});

